const NAMESPACE = "addPrograms";

const KEYS = {
    header: "header",
    existingProgramsSubheader: "existingProgramsSubheader",
    existingProgramsTableEmptyText: "existingProgramsTableEmptyText",
    existingProgramsAgencyColumnHeader: "existingProgramsAgencyColumnHeader",
    existingProgramsProgramColumnHeader: "existingProgramsProgramColumnHeader",
    existingProgramsRoleColumnHeader: "existingProgramsRoleColumnHeader",
    programToAddSubheader: "programToAddSubheader",
    programToAddInstructionText: "programToAddInstructionText",
    noAvailableProgramsText: "noAvailableProgramsText",
    agencySelectLabel: "agencySelectLabel",
    agencySelectDefaultOptionText: "agencySelectDefaultOptionText",
    programSelectLabel: "programSelectLabel",
    programSelectDefaultOptionText: "programSelectDefaultOptionText",
    roleSelectLabel: "roleSelectLabel",
    roleSelectDefaultOptionText: "roleSelectDefaultOptionText",
    addProgramBtnLabel: "addProgramBtnLabel",
    addProgramSuccessAlertText: "addProgramSuccessAlertText",
    redirectProgramToAddInstructionText: "redirectProgramToAddInstructionText",
    redirectWarningMessage: "redirectWarningMessage",
    goToProgramButtonText: "goToProgramButtonText"
};

const MESSAGES = {
    [KEYS.header]: {
        value: "Register for More Programs",
        comment:
            "Header for the Add Programs page which allows users to register for more programs that have roles which allow self-registration"
    },
    [KEYS.existingProgramsSubheader]: {
        value: "Existing Programs",
        comment:
            "Subheader for the section of the Add Programs page that displays the programs for which the user is already registered"
    },
    [KEYS.existingProgramsTableEmptyText]: {
        value: "No existing programs",
        comment:
            "Text that is displayed in the table showing existing programs if the user is not currently registered in any programs"
    },
    [KEYS.existingProgramsAgencyColumnHeader]: {
        value: "Agency",
        comment:
            "The column header in the existing programs table that shows the abbreviated name of the agency to which the program belongs"
    },
    [KEYS.existingProgramsProgramColumnHeader]: {
        value: "Program",
        comment: "The column header in the existing program table that shows the name of the program"
    },
    [KEYS.existingProgramsRoleColumnHeader]: {
        value: "Role",
        comment:
            "The column header in the existing programs table that shows the name of the user's role in that program"
    },
    [KEYS.programToAddSubheader]: {
        value: "Program to Add",
        comment:
            "Subheader for the section of the Add Programs page that allows the user to register for additional programs"
    },
    [KEYS.programToAddInstructionText]: {
        value: "Once you've added a new program, visit your home page and it will appear in your program list.",
        comment:
            "Instruction text informing the user that after registering for additional programs, they can navigate to them from the program selector on their home page"
    },
    [KEYS.noAvailableProgramsText]: {
        value: "There are no more programs available for self-registration.",
        comment: "Text that appears when there are no additional programs for which the user can register"
    },
    [KEYS.agencySelectLabel]: {
        value: "Agency:",
        comment:
            "Label for the selector that allows the user to choose the agency of the new program for which they'd like to register"
    },
    [KEYS.agencySelectDefaultOptionText]: {
        value: "Please select an agency...",
        comment:
            "Text of the default option prompting a user to select an agency to which the program for which they'd like to register belongs"
    },
    [KEYS.programSelectLabel]: {
        value: "Program:",
        comment:
            "Label for the selector that allows the user to select the new program for which they'd like to register"
    },
    [KEYS.programSelectDefaultOptionText]: {
        value: "Please select a program...",
        comment:
            "Text of the default option in the selector where the user gets to choose the name of the new program for which they'd like to register"
    },
    [KEYS.roleSelectLabel]: {
        value: "Role:",
        comment:
            "Label for the selector that allows the user to select the role they'd like in the new program they're registering for"
    },
    [KEYS.roleSelectDefaultOptionText]: {
        value: "Please select a role...",
        comment:
            "Text of the default option in the selector that allows the user to choose the role they'd like in the new program they're registering for"
    },
    [KEYS.addProgramBtnLabel]: {
        value: "Add Program",
        comment: "Label for the button that allows the user to initiate the operation to register for a new program"
    },
    [KEYS.addProgramSuccessAlertText]: {
        value: "Successfully added program.",
        comment: "Alert text informing the user that they successfully registered for a new program"
    },
    [KEYS.redirectProgramToAddInstructionText]: {
        value: "Select Add Program to register in this new program.",
        comment: "Instruction text informing the user how to register for requested program."
    },
    [KEYS.redirectWarningMessage]: {
        value: "Your account is not yet registered for this program. Select the Add Program button below to register.",
        comment:
            "Header message to let the user know why they have been redirected to this page along with instructions on what to do if they didn't mean to land here."
    },
    [KEYS.goToProgramButtonText]: {
        value: "Go to Program",
        comment: "Button text to navigate to the requested program."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
